<template>
  <div class="contact">
        <p style="font-weight: bold">Temporary Closure</p>
        <p style="font-weight: bold; color:red">Due to personal and family health reasons, I am taking an extended leave from the business. I do not currently have a confirmed return date, but I will update this website when I am ready to reopen. I sincerely apologise for any inconvenience and greatly appreciate your understanding, patience, and continued support. Thank you.</p>
  </div>
</template>

<script>
import emailjs from 'emailjs-com';

export default {
  name: 'Contact-Us-Page',
  components: {},
  data() {
    return {
      name: '',
      email: '',
      message: ''
    }
  },
  methods: {
    sendEmail(e) {
      try {
        emailjs.sendForm('service_b4qbnne', 'template_kv81sdc', e.target, 'ychCXjb1RByo8VVVK', {
          name: this.name,
          email: this.email,
          message: this.meessage
        })
      } catch (error) {
          console.log({error})
      }
      // Reset form field
      this.name = ''
      this.email = ''
      this.message = ''
    },
  }
}
</script>

<style scoped>
.contactMediaTitle {
  color: black;
  line-height: 2;
  font-size: 2em;
}
.address {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-style: normal;
  font-size: 1.2em;
  color: black;
  padding: 5px 0px 5px 0px;
}
.container {
  width: 90%;
  padding-left: 5%;
  padding-right: 5%;
}
label {
  float: left;
}
input[type=text], [type=email], textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 16px;
  resize: vertical;
}

input[type=submit] {
  background-color: #74912B;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

input[type=submit]:hover {
  background-color: #2F5E2E;
}

@media only screen and (min-width: 320px) {
  .google-maps {
    position: relative;
    padding-bottom: 75%;
    height: 0;
    overflow: hidden;
  }
  .google-maps iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
  }
  #contactdetails {
    padding-top: 10px;
  }
  #visitus {
    padding-top: 10px;
  }
  .contact {
    font-size: 4vw;
  }
  #contactdetails h1 {
    font-size: 4vw;
  }
  #visitus h1 {
    font-size: 4vw;
  }
  .details {
    font-weight: bold;
    padding-top: 5px;
    font-size: 4vw;
  }
}
@media only screen and (min-width: 1000px) {
  .google-maps {
    position: relative;
    padding-bottom: 75%;
    height: 0;
    overflow: hidden;
  }
  .google-maps iframe {
    position: absolute;
    top: 0;
    left: 0%;
    width: 100% !important;
    height: 100% !important;
  }
  .contact {
    padding-left: 15%;
    padding-right: 15%;
    width: 70%;
    overflow: hidden;
  }
  #contactdetails {
    width: 50%;
    float: left;
    padding-top: 20px;
  }
  #visitus {
    width: 50%;
    float: left;
    padding-top: 20px;
  }
  #contactdetails h1 {
    font-size: 2vw;
    padding-bottom: 20px;
  }
  #visitus h1 {
    text-align: left;
    font-size: 2vw;
    padding-bottom: 20px;
  }
  .details {
    text-align: left;
    font-weight: bold;
    font-size: 1.5vw;
  }
  .details a:hover { 
    text-decoration: none;
    color: #707070;
  }
  .details a:active {
    text-decoration: none;
    color: #707070;
  }
  .details a:link {
    text-decoration: none;
    color: #707070;
  }
  .address {
    text-align: left;
  }
}
</style>
